module.exports = __webpack_public_path__ + "static/img/10.1938ab1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/10.png
// module id = Vh6k
// module chunks = 0